// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2_8cE","addWidgetButton":"Header_addWidgetButton__1h067","dashboardTabs":"Header_dashboardTabs__1fvl7","active":"Header_active__16uHE"};